interface RouteUrl {
  readonly pathname: string
}

export const normalizeRoutePathname = ({ pathname }: RouteUrl): string => pathname || '/'
